/* eslint-disable no-unused-vars */
import * as API from "@/store/actions/axios-api-instance";

export const requestResetPassword = async function requestResetPassword({state}, email) {
    await API.requestResetPassword(email)
}

export const confirmResetPassword = async function confirmResetPassword({state}, {token, password}) {
    // return new Promise(resolve => setTimeout(resolve, 2000))
    await API.confirmResetPassword(token, password)
}